class SectionLightboxLoader extends HTMLElement {
  pathname = this.getAttribute('pathname') || window.location.pathname;
  handle = this.getAttribute('handle') || null;
  sectionId = this.getAttribute('section-id') || null;

  connectedCallback() {
    if (!this.pathname || !this.handle || !this.sectionId) return;
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', () => this.loadSection());
  }

  async loadSection() {
    this.loading();
    const searchParams = new URLSearchParams(document.location.search);
    searchParams.set('section_id', this.sectionId);

    try {
      const response = await fetch(`${this.pathname}?${searchParams.toString()}`);
      if (!response.ok) throw new Error(response.statusText);
      const text = await response.text();
      const html = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('.shopify-section').innerHTML;
      document.body.insertAdjacentHTML('beforeend', html);
      document.getElementById(`${this.handle}`)?.open();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading(false);
    }
  }

  /**
   * loading
   * @param {Boolean} state
   */
  loading(state = true) {
    state ? this.button.classList.add('loading') : this.button.classList.remove('loading');
    state ? this.button.setAttribute('disabled', true) : this.button.removeAttribute('disabled');
  }
}

customElements.define('section-lightbox-loader', SectionLightboxLoader);

class SectionLightbox extends HTMLElement {
  connectedCallback() {
    this.closeClickOutside = (event) => {
      if (!this.querySelector('[data-section-lightbox="content"]').contains(event.target)) {
        this.close();
      }
    };

    this.closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    };

    this.querySelectorAll('[data-section-lightbox="close"]')?.forEach((close) => {
      close.addEventListener('click', () => this.close());
    });

    this.querySelector('[data-section-lightbox="backdrop"]')?.addEventListener('click', () => {
      this.close();
    });
  }

  close() {
    this.classList.remove('open');
    this.setAttribute('aria-hidden', true);
    document.removeEventListener('click', this.closeClickOutside);
    document.removeEventListener('keydown', this.closeOnEscape);

    this.remove();
  }

  open() {
    this.classList.add('open');
    this.setAttribute('aria-hidden', false);
    document.addEventListener('click', (event) => this.closeClickOutside(event));
    document.addEventListener('keydown', (event) => this.closeOnEscape(event));
  }
}

customElements.define('section-lightbox', SectionLightbox);
